module.exports = __webpack_public_path__ + "static/parcel-c887b6676c1569ab38032de13db0833b.jpg";